/**
 * measured-data-details コンポーネント専用i18n定数
 */

export const MEASURED_DATA_DETAILS_I18N = {
  // ツールバー
  toolbar: {
    title: $localize`:@@home.measuredDataDetails.toolbar.title:計測データ詳細`,
  },

  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.measuredDataDetails.breadcrumb.userList:ユーザー一覧`,
    recordList: $localize`:@@home.measuredDataDetails.breadcrumb.recordList:レコードリスト`,
    data: $localize`:@@home.measuredDataDetails.breadcrumb.data:データ`,
  },

  // サマリーカード
  summaryCard: {
    abnormal: {
      present: $localize`:@@home.measuredDataDetails.summaryCard.abnormal.present:あり`,
      absent: $localize`:@@home.measuredDataDetails.summaryCard.abnormal.absent:なし`,
    },
    gostTitle: {
      estimatedEatingAbility: $localize`:@@home.measuredDataDetails.summaryCard.gostTitle.estimatedEatingAbility:推定食事能力`,
      waterSwallowTest: $localize`:@@home.measuredDataDetails.summaryCard.gostTitle.waterSwallowTest:水飲みテスト`,
      generalCondition: $localize`:@@home.measuredDataDetails.summaryCard.gostTitle.generalCondition:全身状態`,
      oralFunction: $localize`:@@home.measuredDataDetails.summaryCard.gostTitle.oralFunction:口腔機能と生活能力`,
    },
  },

  // 波形エラーメッセージ
  waveError: {
    audioNotFound: $localize`:@@home.measuredDataDetails.waveError.audioNotFound:音声ファイルが見つかりません`,
    audioFetchFailed: $localize`:@@home.measuredDataDetails.waveError.audioFetchFailed:音声ファイルを取得できませんでした`,
    decodeError: $localize`:@@home.measuredDataDetails.waveError.decodeError:音声データをデコードできませんでした。\nファイルが破損している可能性があります。`,
  },

  // レコード取得エラー
  recordError: {
    notFoundOrDeleted: $localize`:@@home.measuredDataDetails.recordError.notFoundOrDeleted:対象のデータがありません。`,
    fetchFailed: $localize`:@@home.measuredDataDetails.recordError.fetchFailed:サーバからの情報が取得できませんでした。`,
  },
} as const;

export type MeasuredDataDetailsI18n = typeof MEASURED_DATA_DETAILS_I18N;
